import toast, { type ToastOptions } from 'react-hot-toast';

const config: ToastOptions = {
  position: 'bottom-center',
};

export const useTaost = () => {
  const successToast = (msg: string) => {
    toast.success(msg, config);
  };

  const errorToast = (msg: string) => {
    toast.error(msg, config);
  };

  return { successToast, errorToast };
};
